import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TreeNode } from 'ui-library';
import { MenuItemComponent } from './../menu-item/menu-item.component';

@Component({
  selector: 'app-dropdown-menu',
  standalone: true,
  imports: [
    MenuItemComponent,
    MatIconModule,
    RouterLink,
    MatMenuModule,
    MatButtonModule,
    CommonModule,
    TranslateModule
  ],
  templateUrl: './dropdown-menu.component.html',
  styleUrl: './dropdown-menu.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class DropdownMenuComponent {
  // Variables
  private _userRole: string = '';

  // Component API
  @Input() nodes: TreeNode[] = [];
  @Input() trigger: string = 'submenu';

  @Input()
  set userRole(value: string) {
    this._userRole = value;
  }

  get userRole(): string {
    return this._userRole;
  }

  get filteredNodes(): TreeNode[] {
    return this.nodes.filter(node => this.hasAccess(node));
  }

  menus = [
    {
      label: 'File',
      children: [
        { label: 'New', children: [{ label: 'Project' }, { label: 'File' }] },
        { label: 'Open' },
        { label: 'Save' }
      ]
    },
    {
      label: 'Edit',
      children: [
        { label: 'Cut' },
        { label: 'Copy' },
        { label: 'Paste' }
      ]
    }
  ];

  constructor() { }

  hasAccess(node: TreeNode): boolean {
    if (!node.role || node.role.length === 0) return true;

    return node.role.includes(this.userRole);
  }
}
